import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { en } from './langs/en'
import { cn } from './langs/cn'

Vue.use(VueI18n)

export default new VueI18n({
  locale: localStorage.getItem('language') || 'cn',
  fallbackLocale: 'cn',
  messages: {
    en, cn
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/lang.ts